import React, { useEffect } from "react";

import {
  FaExclamationTriangle,
  FaTimes,
} from "react-icons/fa";

import {
  cf,
  getReglementUser,
  getUserFullName,
} from "../utils/dashboard.utils";

export default function DeleteReglementModal({
  reglement,
  deleting = false,
  onClose,
  onConfirm,
}) {
  useEffect(() => {
    if (!reglement) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [reglement]);

  if (!reglement) return null;

  const user = getReglementUser(reglement);

  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-slate-950/65 p-4 backdrop-blur-sm">
      <button
        type="button"
        aria-label="Fermer"
        className="absolute inset-0 cursor-default"
        onClick={deleting ? undefined : onClose}
      />

      <div className="relative z-10 w-full max-w-md overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-2xl dark:border-slate-700 dark:bg-slate-900">
        <header className="flex items-center justify-between border-b border-slate-200 px-5 py-4 dark:border-slate-800">
          <div className="flex items-center gap-3">
            <div className="rounded-2xl bg-rose-500/10 p-3 text-rose-600 dark:text-rose-300">
              <FaExclamationTriangle />
            </div>

            <h3 className="font-bold text-slate-900 dark:text-white">
              Supprimer cet achat
            </h3>
          </div>

          <button
            type="button"
            onClick={onClose}
            disabled={deleting}
            className="rounded-xl p-2 text-slate-500 transition hover:bg-slate-100 dark:hover:bg-slate-800"
          >
            <FaTimes />
          </button>
        </header>

        <div className="space-y-4 p-5">
          <p className="text-sm leading-6 text-slate-600 dark:text-slate-300">
            Cette suppression est définitive. L’achat ne
            sera plus comptabilisé dans les revenus du
            Dashboard.
          </p>

          <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/50">
            <div className="font-semibold text-slate-900 dark:text-white">
              {getUserFullName(user)}
            </div>

            <div className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              {reglement.formule || "Sans formule"}
            </div>

            <div className="mt-3 text-xl font-bold text-slate-900 dark:text-white">
              {cf.format(
                Number(reglement.prix_total || 0),
              )}
            </div>
          </div>
        </div>

        <footer className="flex flex-col-reverse gap-2 border-t border-slate-200 bg-slate-50 px-5 py-4 dark:border-slate-800 dark:bg-slate-900 sm:flex-row sm:justify-end">
          <button
            type="button"
            onClick={onClose}
            disabled={deleting}
            className="rounded-xl border border-slate-300 bg-white px-4 py-2.5 font-semibold text-slate-700 transition hover:bg-slate-100 disabled:opacity-50 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
          >
            Annuler
          </button>

          <button
            type="button"
            onClick={onConfirm}
            disabled={deleting}
            className="rounded-xl bg-rose-600 px-4 py-2.5 font-semibold text-white transition hover:bg-rose-500 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {deleting
              ? "Suppression..."
              : "Supprimer définitivement"}
          </button>
        </footer>
      </div>
    </div>
  );
}